.banner {
  align-items: center;
  background-color: #00e889;
  bottom: 66px;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 2rem;
  position: fixed;
  width: 100%;
  z-index: var(--cxy-z-index-cookie-banner);
  justify-content: center;
  flex-direction: column;
  font-family: var(--ogm-font-family-2);
  gap: 0.5rem;
  box-shadow: 0px -2px 4px 0px #00000040;
  padding: 1rem;

  @media (min-width: 1024px) {
    bottom: 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.bannerText {
  margin: 0;
  font-family: Public Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: flex-start;
  color: #022e4a;
  justify-content: flex-start;
  gap: 0.5rem;

  @media (min-width: 1024px) {
    align-items: center;
    font-size: 18px;
  }
}

.iconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1.5rem;

  @media (min-width: 1024px) {
    max-width: 2rem;
  }
}

.acceptButton {
  margin-top: 8px;
  background-color: unset;
  border: 1px solid #022e4a;
  border-radius: 4px;
  color: #022e4a;
  cursor: pointer;
  padding: 0.5rem 1rem;
  margin: 0;
  font-family: Public Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: flex-start;
  color: #022e4a;
  justify-content: flex-start;
  gap: 0.5rem;

  @media (min-width: 1024px) {
    margin-top: 0;
    margin-left: 0.5rem;
    font-size: 18px;
  }
}

.link {
  text-decoration: none;
  color: #022e4a;
}
